<nav class="nav-str">
  @for (item of naviString; track item; let i = $index) {
    <span>
      <a [routerLink]="item.link" [queryParams]="item.params" [fragment]="item.fragment" >{{item.text}}</a>
      {{i < (naviString.length - 1) ? ">" : ""}}
    </span>
  }
</nav>
